var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 188,
    viewBox: "0 0 199 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 188
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_5",
    "data-name": "Artboard \\u2013 5",
    clipPath: "url(#clip-Artboard_5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7_1_",
    "data-name": "Group (7) (1)",
    transform: "translate(21.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M78,156A78,78,0,1,0,0,78,78,78,0,0,0,78,156Z",
    fill: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M63.822,117.692V182.9h4.572V121.111",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M63.822,117.692V182.9h4.572V121.111",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M71.25,87.57v65.2h4.579V90.988",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M71.25,87.57v65.2h4.579V90.988",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M145.291,97.046v55.723h-4.58V90.988",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M145.291,97.046v55.723h-4.58V90.988",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M153.158,117.692V182.9h-4.579V121.111",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M153.158,117.692V182.9h-4.579V121.111",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M15.2,84.036v69.332c0,.411-.707.743-1.572.743s-1.572-.332-1.572-.743V84.036H15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M43.175,71.553l8.344,68.834c.05.4-.613.822-1.478.923s-1.6-.137-1.651-.548L40.045,71.928l3.13-.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M21.389,55.594,5.776,123.152c-.094.4-.851.562-1.7.367s-1.464-.678-1.37-1.074L18.317,54.887Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M4.781,49.039l4.2,63.064,12.541-6.252L17.25,46.7Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M5.25,48.959l4.2,63.065L22,105.772,17.719,46.623Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M5.719,48.88l4.2,63.072L22.464,105.7,18.188,46.55Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M6.188,48.8l4.2,63.073,12.548-6.253L18.649,46.471Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M7.276,48.584l38.416-6.9s.022,24.743,6,39.014a84.871,84.871,0,0,0,7.421,12.88L23.185,108.051S6.382,88.507,7.276,48.591Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M45.786,45.707,6.476,53.149H4.781L4.493,48.44l2.048-.281,39.151-6.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M153.159,117.692H63.822v5.113h89.337Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M153.159,117.692H63.822l7.536-31.759H142.19Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M85.615,95.358c6.054,0,10.962-1.937,10.962-4.327S91.669,86.7,85.615,86.7s-10.962,1.937-10.962,4.327S79.562,95.358,85.615,95.358Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M78.533,78.721c.75,1.305,10.046,2.409,15.252-.8C100.55,73.753,76.673,75.5,78.533,78.721Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M87.541,80.914s-1.4-20.683-2.986-26.928-4.752-7.875-5.12-4.139c-.6,6.173,3.512,21.584,8.1,31.067Z",
    fill: "#efc003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M82.9,59.1l4.637,21.815",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M87.346,81.909s-.375-18.137,1.132-22.8,5.192-5.5,6.7-1.731-7,22.954-7.825,24.534Z",
    fill: "#efc003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M91.326,61.889,87.656,81.115",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M87.656,81.692S81,57.469,75.289,57.916,78.866,74.5,87.656,81.692Z",
    fill: "#efc003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M87.656,81.692S76.767,67.168,71.495,67.616,80.329,80.712,87.656,81.692Z",
    fill: "#efc003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M87.98,81.692s13.875-11.712,13.118-16.94S88.536,74.329,87.98,81.692Z",
    fill: "#efc003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M77.488,63.094,87.3,81.3,73.536,71.07",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M98.033,68.452,87.656,81.692",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M82.738,91.291C84.945,93.159,92.02,93,93.707,90.036s1.284-13.4,1.284-13.4a13.02,13.02,0,0,1-9.1,3.108c-5.618-.252-7.464-1.392-7.464-1.392s1.9,10.889,4.305,12.93Z",
    fill: "#4f84e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M152.582,80.921l-1.154,3.454L108.289,52.24,112.262,52l39.75-1.846Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M151.211,84.137l-42.721-2.5V52.45l42.721-1.37Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M150.187,82.435,109.4,80.957V53.611l40.788-1.716Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M127.659,82.759a5.076,5.076,0,0,1-.022,1.558,4.159,4.159,0,0,1-2.372,3.159c-3,1.457-.26,3.339,1.543,3.815s7.2.9,8.481-.728-1.176-2.524-1.14-4.969l.036-2.445-6.519-.382Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M134.156,84.779l-6.389-.4-.108-1.615,6.519.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M119.116,62.077l-2.3-.334a1.356,1.356,0,0,0-1.537,1.146l-.334,2.3a1.355,1.355,0,0,0,1.146,1.537l2.3.334a1.356,1.356,0,0,0,1.537-1.146l.334-2.3A1.355,1.355,0,0,0,119.116,62.077Z",
    fill: "#efc003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M129.353,72.563l-.382-.166a.314.314,0,0,1-.166-.418l.166-.382a.31.31,0,0,0-.166-.418l-.829-.353a.31.31,0,0,0-.419.166l-.165.382a.315.315,0,0,1-.419.166l-.382-.166a.309.309,0,0,0-.418.166l-.354.829a.31.31,0,0,0,.166.418l.382.166a.314.314,0,0,1,.166.418l-.166.382a.31.31,0,0,0,.166.418l.83.353a.309.309,0,0,0,.418-.166l.166-.382a.314.314,0,0,1,.418-.166l.382.166a.31.31,0,0,0,.419-.166l.353-.829A.31.31,0,0,0,129.353,72.563Z",
    fill: "#f38539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M141.693,57.381l-1.334.566a.845.845,0,0,0-.448,1.106l.566,1.334a.845.845,0,0,0,1.107.447l1.334-.566a.844.844,0,0,0,.447-1.106l-.565-1.334A.845.845,0,0,0,141.693,57.381Z",
    fill: "#4069df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M92.784,99.188H133.7a.634.634,0,0,1,.606.454l2.61,9.007a.632.632,0,0,1-.613.808l-47.365-.548a.633.633,0,0,1-.57-.895L92.2,99.555a.629.629,0,0,1,.577-.368Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M92.784,97.9H133.7a.634.634,0,0,1,.606.454l2.61,9.007a.632.632,0,0,1-.613.808l-47.365-.548a.633.633,0,0,1-.57-.894L92.2,98.265a.629.629,0,0,1,.577-.368Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M91.067,104.668l42.836.916",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M92.61,101.812l34.327.686",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M127.659,100.276l.252,3.765H133.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M127.659,100.276l.252,3.765H133.9",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M93.52,99.418l32.5.339",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M45.786,81.3l-23.322,7.94C16.919,82.017,15.2,63.086,15.2,63.086",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M45.786,81.3l-23.322,7.94C16.919,82.017,15.2,63.086,15.2,63.086",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M21.389,79.406l21.786-7.853",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M22.933,83.942l21.786-7.861",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M20.077,72.678,41.892,66.31",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M23.358,87.663s16.37-8.863,17.12-25.471",
    fill: "none",
    stroke: "#b480d7",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M38.726,64.255l1.752-2.611.728,3",
    fill: "none",
    stroke: "#b480d7",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.82658377.svg";
export { ForwardRef as ReactComponent };